import { useTheme } from "@emotion/react";
import { BarTimeChart } from "./bar_time_chart";
import { applyAutoScale } from "./chart_options";

export function PeakChart({ peakData, multiDay = false }) {
  const theme = useTheme();

  const naturalPeakConfirmed = peakData.map((el) => (Number(el.natural_is_valid) === 1 ? el.naturalpeak : null));
  const naturalPeakUncertain = peakData.map((el) => (Number(el.natural_is_valid) === 1 ? null : el.naturalpeak));
  const drawnPeakConfirmed = peakData.map((el) => (Number(el.drawn_is_valid) === 1 ? el.drawnpeak : null));
  const drawnPeakUncertain = peakData.map((el) => (Number(el.drawn_is_valid) === 1 ? null : el.drawnpeak));

  const accessPowerData = peakData.map((el) => el.accesspower);

  const data = {
    labels: peakData.map((el) => new Date(1000 * el.period)),
    datasets: [
      {
        label: "Natural peak",
        data: naturalPeakConfirmed,
        borderWidth: 0,
        backgroundColor: theme.palette.naturalPeak.main,
        stack: "naturalPeak",
      },
      {
        label: "Natural peak (uncertain)",
        data: naturalPeakUncertain,
        borderWidth: 0,
        backgroundColor: theme.palette.naturalPeak.gray,
        stack: "naturalPeak",
      },
      {
        label: "Actual peak",
        data: drawnPeakConfirmed,
        borderWidth: 0,
        backgroundColor: theme.palette.drawnPeak.main,
        stack: "drawnPeak",
      },
      {
        label: "Actual peak (uncertain)",
        data: drawnPeakUncertain,
        borderWidth: 0,
        backgroundColor: theme.palette.drawnPeak.gray,
        stack: "drawnPeak",
      },
      {
        label: "Access power",
        data: accessPowerData,
        borderWidth: 3,
        borderColor: theme.palette.setPeak.main,
        backgroundColor: "transparent",
        pointStyle: false,
        stepped: true,
        type: "line",
        order: -1,
        spanGaps: false,
        yAxisID: "yLines",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },

    plugins: {
      legend: {
        position: "bottom",
        display: true,
        labels: {
          filter: (legendItem) => !legendItem.text.includes("(uncertain)"),
        },
      },
    },

    scales: {
      x: {
        type: "time",
        time: {
          tooltipFormat: "MMMM yyyy",
          displayFormats: {
            month: "MMM yyyy",
          },
          unit: "month",
        },
        stacked: true,
        offset: true,
        ticks: {
          source: "data",
        },
        grid: {
          offset: true,
        },
      },
      y: {
        stacked: true,
      },
      yLines: {
        display: false,
        stacked: false,
        afterBuildTicks: function (axis) {
          const yAxis = axis.chart.scales.y;
          if (yAxis) {
            axis.min = yAxis.min;
            axis.max = yAxis.max;
          }
        },
      },
    },
  };

  const allDataArrays = [
    naturalPeakConfirmed,
    naturalPeakUncertain,
    drawnPeakConfirmed,
    drawnPeakUncertain,
    accessPowerData,
  ];
  applyAutoScale(options, allDataArrays, "kVA");

  const allValues = allDataArrays.flat().filter((v) => v != null && !isNaN(v));
  if (allValues.length > 0) {
    options.scales.y.suggestedMax = Math.max(...allValues);
  }

  return <BarTimeChart data={data} options={options} />;
}
